"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionDuplicateModalCtrl = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const mobx_1 = require("mobx");
const services_1 = require("../../services");
const store_1 = require("../../store");
class CollectionDuplicateModalCtrl {
    constructor(collections) {
        this.duplicating = false;
        this.collections = collections;
    }
    //we take the departmentId as a parameter to make inter department duplication easier to implement even if it is not currently needed
    duplicateCollections(departmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.duplicating) {
                return;
            }
            const collectionsByTag = {};
            for (const collection of this.collections) {
                const tagId = collection.tags.find((t) => !(0, core_api_1.isSystemTag)(t));
                if (collectionsByTag[tagId] != null) {
                    collectionsByTag[tagId].push(collection);
                }
                else {
                    collectionsByTag[tagId] = [collection];
                }
            }
            this.setDuplicating(true);
            for (const tagId of Object.keys(collectionsByTag)) {
                const collectionGroup = collectionsByTag[tagId];
                const tag = store_1.AppStore.Tag.get(tagId);
                if (departmentId == null) {
                    yield services_1.Services.Collection.duplicate(collectionGroup, tag.name);
                }
                else {
                    yield services_1.Services.Collection.duplicate(collectionGroup, tag.name, departmentId);
                }
            }
            this.setDuplicating(false);
        });
    }
    setDuplicating(duplicating) {
        this.duplicating = duplicating;
    }
}
exports.CollectionDuplicateModalCtrl = CollectionDuplicateModalCtrl;
tslib_1.__decorate([
    mobx_1.observable
], CollectionDuplicateModalCtrl.prototype, "tagName", void 0);
tslib_1.__decorate([
    mobx_1.observable
], CollectionDuplicateModalCtrl.prototype, "duplicating", void 0);
tslib_1.__decorate([
    mobx_1.action
], CollectionDuplicateModalCtrl.prototype, "setDuplicating", null);
//# sourceMappingURL=collection.duplicate.modal.ctrl.js.map